import { useMatch } from "@/api/services/admin/match";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { MatchInfoItem } from "@/features/match/components/MatchInfoItem";
import { styled } from "@mui/system";
import { black, divider } from "@/theme/colors";

export const MatchDescription = () => {
  const { data: matchResult } = useMatch();

  const matchData = matchResult?.data;

  return (
    <MatchInnerBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <MatchInfoItem label="紹介会社情報" value={matchData?.description} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <MatchInfoItem label="備考" value={matchData?.note} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" spacing={2} justifyContent="space-around">
            <Stack direction="column" spacing={2}>
              <Typography variant="cap12" color={black[70]}>
                有効求人数
              </Typography>
              <Typography variant="head24Bold">{matchData?.jobCount ?? 0} 件</Typography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <Typography variant="cap12" color={black[70]}>
                有効人材数
              </Typography>
              <Typography variant="head24Bold">{matchData?.talentCount ?? 0} 人</Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </MatchInnerBox>
  );
};

const MatchInnerBox = styled(InnerBox)`
  border: 1px solid ${divider.high};
  padding: 8px;
`;
